import React from 'react'
import ScreenHeading from './ScreenHeading';

import styles from './screenbase.module.css';
import { IResponse, IResponses, Question } from './QuestionsList';
import Footer from './Footer';
import { Spin } from 'antd';

export interface BaseScreenProps {
  index: number,
  isActive: boolean,
  data: Question,
  replaceTokens(input: string, responses?: IResponses): string,
  locked?: boolean,
  responses: IResponses
}

export interface ScreenProps extends BaseScreenProps {
  onSubmit: (response: IResponse) => Promise<void>
}

export interface WithScreenProps extends BaseScreenProps {
  onNext: (response: IResponse) => Promise<boolean>
}

interface WithScreenState {
  initialTime: number,
  saving: boolean
}

export default function WithScreen (WrappedComponent: React.ComponentType<ScreenProps>) {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  return class ComponentWithScreen extends React.Component<WithScreenProps, WithScreenState> {
    public static displayName = `withScreen(${displayName})`;
    
    state: WithScreenState = {
      initialTime: 0,
      saving: false
    }

    componentDidMount() {
      this.setState({ initialTime: Date.now() });
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    getElapsedSeconds = () => {
      return this.state.initialTime ? Math.floor((Date.now() - this.state.initialTime)/1000) : 0;
    }

    onSubmit = async (response: { value?: number, text?: string, options?: number[]}) => {
      this.setState({ saving: true });
      const success = await this.props.onNext({ ...response, time: this.getElapsedSeconds() });
      if(!success) this.setState({ saving: false });
    }

    render() {
      const { title, description, image, type, order } = this.props.data;
      return <div className={styles.screen}>
        <ScreenHeading title={title} description={description} image={image} replaceTokens={this.props.replaceTokens} />
        <div className={styles.screenBody}>
          <Spin spinning={this.state.saving}>
            <WrappedComponent {...(this.props as BaseScreenProps)} onSubmit={this.onSubmit} locked={this.props.locked} />
          </Spin> 
        </div>
        { (order === 1 || type === 'ThankYou') && <Footer />}
      </div>;
    }
  };
}